export default function dateFormats(date) {
  if (!date) return '';
  // If ISO-like string, return the YYYY-MM-DD part directly to avoid TZ shifts
  if (typeof date === 'string') {
    const m = date.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const day = ('0' + d.getDate()).slice(-2);
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
}

/**
 * Mosha e sotme nga datëlindja — vite të plota.
 *
 * Nuk është `sot.getFullYear() - lindja.getFullYear()`: ai numër e rrit moshën
 * në 1 janar, jo në ditëlindje, dhe gabon për gjysmën e vitit te çdo punonjës.
 * Muaji dhe dita krahasohen gjithmonë.
 *
 * Vargu ISO lexohet me copëza (si te `dateFormats`), pa e kaluar nëpër `Date`:
 * `new Date('1990-05-10')` është mesnatë UTC dhe në zonat perëndimore bie një
 * ditë prapa — mjaft sa ditëlindja të "vonohet" një ditë.
 *
 * Kthen `null` kur data mungon, nuk lexohet, është në të ardhmen ose jep një
 * moshë të pamundur (>130). Në ato raste ekrani duhet të mos tregojë asgjë:
 * një gabim shtypi te viti nuk guxon të dalë si «936 vjeç».
 */
export function ageFromBirthDate(birth, today = new Date()) {
  if (!birth) return null;

  let y, m, d;
  if (typeof birth === 'string') {
    const iso = birth.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) { y = +iso[1]; m = +iso[2]; d = +iso[3]; }
  }
  if (y === undefined) {
    const dt = new Date(birth);
    if (isNaN(dt.getTime())) return null;
    y = dt.getFullYear(); m = dt.getMonth() + 1; d = dt.getDate();
  }

  const ty = today.getFullYear(), tm = today.getMonth() + 1, td = today.getDate();
  let age = ty - y;
  if (tm < m || (tm === m && td < d)) age -= 1;

  if (!Number.isFinite(age) || age < 0 || age > 130) return null;
  return age;
}

/**
 * Data për t'u lexuar nga njeriu: `19.04.1984` — ditë, muaj, vit.
 *
 * `dateFormats` mbetet formati i makinës (`YYYY-MM-DD`): atë e duan `input
 * type="date"`, renditjet dhe payload-et, ndaj nuk preket. Ky është vetëm për
 * ekran, ndaj rri veçmas — një funksion i vetëm për të dyja do të thoshte se
 * ndryshimi i pamjes prek edhe atë që dërgohet te serveri.
 *
 * Copëzat lexohen nga vargu, jo nga `new Date`: `new Date('1984-04-19')` është
 * mesnatë UTC dhe në zonat perëndimore kthehet 18 prill.
 */
export function formatDMY(value, sep = '.') {
  if (!value) return '';
  let y, m, d;
  if (typeof value === 'string') {
    const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) { y = iso[1]; m = iso[2]; d = iso[3]; }
  }
  if (y === undefined) {
    const dt = new Date(value);
    if (isNaN(dt.getTime())) return '';
    y = String(dt.getFullYear());
    m = ('0' + (dt.getMonth() + 1)).slice(-2);
    d = ('0' + dt.getDate()).slice(-2);
  }
  return `${d}${sep}${m}${sep}${y}`;
}
